import styled from "styled-components";

export const ContactWrapper = styled.div`
  background-color: var(--card-bg-green-color);
  position: relative;
  @media (max-width: 1024px) {
    position: static;
    margin-top: 100px;
  }
  @media (max-width: 580px) {
    background-color: unset;
    margin-top: 45px;
  }
`;
export const ContactContainer = styled.section`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  /* @media (max-width: 900px) {
    justify-content: space-between;
  }
  @media (max-width: 600px) {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-top: 2rem;
    margin-left: 2rem;
  }
  @media (max-width: 600px) {
    padding-top: 4rem;
    margin-top: 2rem;
  } */
`;
export const ContactFormContainer = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  margin-right: 30px;
  @media (max-width: 1024px) {
    width: 100%;
    padding: 40px 0;
    align-items: center;
  }
  @media (max-width: 600px) {
    margin-right: 0;
  }
`;
export const ContactImaContainer = styled.div`
  /* @media (max-width: 900px) {
    width: 40%;
  } */
  img {
    width: 100%;
    display: block;
    height: auto;
  }

  @media (max-width: 1024px) {
    display: none;
  }
`;
export const FormWrapper = styled.div`
  width: 100%;
  display: flex;
  margin-top: 28px;
  input,
  textarea {
    background: rgba(255, 255, 255, 0.2);
    border: 1px solid rgba(255, 255, 255, 0.6);
    border-radius: 2px;
    @media (max-width: 580px) {
      border: 1px solid #92d5bd;
    }
    &::placeholder {
      color: var(--title-color);
      font-size: 1.4rem;
      font-weight: 600;
      margin: 0;
      @media (max-width: 580px) {
        color: #bebfc0;
      }
    }
  }

  @media (max-width: 580px) {
    flex-direction: column;
  }
`;

export const TextContainer = styled.div`
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  margin-top: 1.2rem;
  @media (max-width: 768px) {
    width: ${(props) => props.width768 || "500px"};
  }
  p {
    font-weight: 700;
    font-family: Peyda;
    font-size: 3.2rem;
    line-height: 5.6rem;
    color: var(--white-color);
    @media (max-width: 768px) {
      font-size: 2.6rem;
      line-height: 2rem;
    }
  }

  @media (max-width: 525px) {
    font-size: 1.6rem;
  }
`;

export const TitleContainer = styled.div`
  width: ${(props) => props.width || "23%"};
  position: relative;

  span {
    display: inline-block;
    width: 11.11px;
    height: 21px;
    position: absolute;
    top: 52px;
    left: 98%;
    background-color: ${(props) => props.color || "#fff"};
  }
  h5 {
    font-size: 1.6rem;
    font-weight: 800;
    color: ${(props) => props.titleColor || "#FFFFFF"};
    opacity: ${(props) => props.opacity || "1"};
    margin-bottom: 0.6rem;
    font-family: Peyda;
  }
  p {
    font-size: 3.2rem;
    font-weight: 700;
    line-height: 5.3rem;
    padding-right: 1.4rem;
    color: ${(props) => props.textColor || "#FFFFFF"};
    @media (max-width: 480px) {
      padding-right: 0;
    }
  }
  @media (max-width: 1200px) {
    p {
      font-size: 3rem;
    }
  }
  @media (max-width: 1024px) {
    width: 100%;
    p {
      font-size: 2.8rem;
    }
  }

  @media (max-width: 600px) {
    width: 100%;
    p {
      font-size: 2.2rem;
    }
  }
  @media (max-width: 525px) {
    p {
      font-size: 2rem;
    }
  }
`;

export const FormColumnLeft = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  margin-right: 26px;
  height: 200px;
  @media (max-width: 1024px) {
    margin-right: 8px;
    height: 176px;
  }
  @media (max-width: 580px) {
    height: 200px;
    margin-right: 0;
  }
`;
export const FormColumnRight = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  height: 200px;
  @media (max-width: 1024px) {
    height: 176px;
  }
  @media (max-width: 580px) {
    height: 182px;
    justify-content: space-around;
  }
`;

export const ButtonContainer = styled.div``;

export const Button = styled.button`
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  background: ${(props) => props.background || "#6CAEFF"};
  border-radius: ${(props) => props.radius || "2px"};
  border-width: ${(props) => props.borderSize};
  border-color: ${(props) => props.borderColor};
  border-style: ${(props) => props.style || "solid"};
  color: ${(props) => props.color || "#fff"};
  font-family: Peyda;
  font-style: normal;
  text-align: center;
  cursor: pointer;
  transition: 0.7s;
  &:hover {
    background: ${(props) => props.backgroundHover || "#448ce4"};
    border-color: ${(props) => props.borderColorHover || "#448ce4"};
    color: ${(props) => props.colorHover};
  }
  &:disabled {
    background: ${(props) => props.background || "#99b9e0"};
    border-color: ${(props) => props.borderColor || "#99b9e0"};
    cursor: auto;
  }
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 700;
  @media (max-width: 1440px) {
    width: ${(props) => props.width1440 || "280px"};
  }
  @media (max-width: 1312px) {
    width: ${(props) => props.width1312 || "256px"};
  }
  @media (max-width: 1150px) {
    width: ${(props) => props.width1150 || "230px"};
  }
  @media (max-width: 1024px) {
    width: ${(props) => props.width600 || "264px"};
  }
  @media (max-width: 580px) {
    width: ${(props) => props.width580 || "328px"};
    height: 42px;
  }
`;
